import {
  Box,
  ImageList,
  ImageListItem,
  Modal,
  Typography,
} from "@mui/material";
import ButtonComponent from "../Inputs/ButtonComponent";
import "../../CSS/ComponentCSS/EXModal.css";
import { useEffect, useState } from "react";
import Loading from "../LoadingBar/Loading";
import AlertComponent from "../Alert/AlertComponent";
import api from "../../API/api";
import { filesList } from "../CommonFunction";

type EXModalProps = {
  open: boolean;
  p_id: number;
  onClose: (value: boolean) => void;
};
export default function EXModal(props: EXModalProps) {
  const [alert, setAlert] = useState(false);
  const [loading, setLoading] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [list, setList] = useState([]);

  useEffect(() => {
    const getPicture = async () => {
      setLoading(true);
      const picture = await api.get(`/Question/getEXFile?p_id=${props.p_id}`);
      setLoading(false);
      if (picture != undefined) {
        setList(picture);
      } else {
        setAlert(true);
        setAlertMessage("데이터 조회에 실패하였습니다.");
      }
    };
    getPicture();
  }, []);

  return (
    <Modal open={props.open} onClose={props.onClose}>
      <>
        <Box className="EXModalBox">
          <Box className="EXModalInnerBox">
            <ImageList sx={{ width: "100%" }} cols={2} gap={1}>
              {list
                ? list.map((item: any, index: any) => (
                    <ImageListItem key={index}>
                      <img
                        srcSet={`${filesList(
                          item
                        )}?w=164&h=164&fit=crop&auto=format&dpr=2 2x`}
                        src={`${filesList(item)}?auto=format`}
                        loading="lazy"
                        style={{
                          width: "100%",
                          height: "450px",
                          objectFit: "contain",
                        }}
                      />
                    </ImageListItem>
                  ))
                : ""}
            </ImageList>
          </Box>
          <div className="EXModalBottom">
            <ButtonComponent
              fullWidth
              variant="contained"
              onClick={() => props.onClose(true)}
              className="EXModalUpdateButton"
            >
              확인
            </ButtonComponent>
          </div>
        </Box>
        {alert && (
          <AlertComponent value={alert} setValue={setAlert} info="error">
            {alertMessage}
          </AlertComponent>
        )}
        {loading && <Loading />}
      </>
    </Modal>
  );
}
